import React, { Fragment } from 'react';

import TEXT from '../../../../../../data/text.json';

import TextBox from '../../../form-components/text-box';
import DropDown from '../../../form-components/drop-down';
import ErrorMessage from '../../../form-components/error-message';

export default ({
  // Used to select which fields to show
  itemTypeValue,
  setItemTypeValue,

  // Data values
  locationValue,
  setLocationValue,
  yearValue,
  setYearValue,
  designerValue,
  setDesignerValue,
  productionMethodValue,
  setProductionMethodValue,
  productionLocationValue,
  setProductionLocationValue,
  tablewareTypeValue,
  setTablewareTypeValue,
  patternNumberValue,
  setPatternNumberValue,
  colorValue,
  setColorValue
}) => (
  <div>
    {!itemTypeValue && (
      <Fragment>
        <ErrorMessage message="You must select the item's type before being able to enter it's details." />
        <DropDown
          required
          id={TEXT.FORMS.itemTypeId}
          label={TEXT.FORMS.itemTypeLabel}
          selectedValue={itemTypeValue}
          onChange={setItemTypeValue}
          options={[
            { text: TEXT.FORMS.itemTypePlaceholder, value: '' },
            { text: 'Tableware Glass', value: 'TABLEWARE' },
            { text: 'Stained Glass Window', value: 'WINDOW' }
          ]}
        />
      </Fragment>
    )}
    {itemTypeValue === 'WINDOW' && (
      <Fragment>
        <TextBox
          id={TEXT.FORMS.locationId}
          label={TEXT.FORMS.locationLabel}
          placeholder={TEXT.FORMS.locationPlaceholder}
          value={locationValue}
          onChange={setLocationValue}
        />
        <TextBox
          id={TEXT.FORMS.yearId}
          label={TEXT.FORMS.yearLabel}
          placeholder={TEXT.FORMS.yearPlaceholder}
          value={yearValue}
          onChange={setYearValue}
        />
        <TextBox
          id={TEXT.FORMS.designerId}
          label={TEXT.FORMS.designerLabel}
          placeholder={TEXT.FORMS.designerPlaceholder}
          value={designerValue}
          onChange={setDesignerValue}
        />
        <DropDown
          id={TEXT.FORMS.productionMethodId}
          label={TEXT.FORMS.productionMethodLabel}
          options={TEXT.FORMS.productionMethodWindowOptions}
          value={productionMethodValue}
          onChange={setProductionMethodValue}
        />
        <DropDown
          id={TEXT.FORMS.productionLocationId}
          label={TEXT.FORMS.productionLocationLabel}
          options={TEXT.FORMS.productionLocationOptions}
          value={productionLocationValue}
          onChange={setProductionLocationValue}
        />
      </Fragment>
    )}

    {itemTypeValue === 'TABLEWARE' && (
      <Fragment>
        <TextBox
          id={TEXT.FORMS.tablewareTypeId}
          label={TEXT.FORMS.tablewareTypeLabel}
          placeholder={TEXT.FORMS.tablewareTypePlaceholder}
          value={tablewareTypeValue}
          onChange={setTablewareTypeValue}
        />
        <DropDown
          id={TEXT.FORMS.productionMethodId}
          label={TEXT.FORMS.productionMethodLabel}
          options={TEXT.FORMS.productionMethodTablewareOptions}
          value={productionMethodValue}
          onChange={setProductionMethodValue}
        />
        <TextBox
          id={TEXT.FORMS.patternNumberId}
          label={TEXT.FORMS.patternNumberLabel}
          placeholder={TEXT.FORMS.patternNumberPlaceholder}
          value={patternNumberValue}
          onChange={setPatternNumberValue}
        />
        <TextBox
          id={TEXT.FORMS.colorId}
          label={TEXT.FORMS.colorLabel}
          placeholder={TEXT.FORMS.colorPlaceholder}
          value={colorValue}
          onChange={setColorValue}
        />
        <TextBox
          id={TEXT.FORMS.designerId}
          label={TEXT.FORMS.designerLabel}
          placeholder={TEXT.FORMS.designerPlaceholder}
          value={designerValue}
          onChange={setDesignerValue}
        />
        <TextBox
          id={TEXT.FORMS.yearId}
          label={TEXT.FORMS.yearLabel}
          placeholder={TEXT.FORMS.yearPlaceholder}
          value={yearValue}
          onChange={setYearValue}
        />
        <DropDown
          id={TEXT.FORMS.productionLocationId}
          label={TEXT.FORMS.productionLocationLabel}
          options={TEXT.FORMS.productionLocationOptions}
          value={productionLocationValue}
          onChange={setProductionLocationValue}
        />
      </Fragment>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/new-item-form/stage-2/index.js